import React, { useState } from "react";
import { CSVDownloader } from "react-papaparse";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Menu from "@material-ui/core/Menu";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from "@material-ui/core/CircularProgress";

import { makeStyles, withStyles } from "@material-ui/core/styles";

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

export default function CSVDownload(props) {
  const { rowList, data, headCells, productsAmount, getFullList } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [rowsSelected, setRowList] = useState(rowList);
  const [fileName, setFileName] = useState("download");
  // const [filteredData, setData] = useState(rowList);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (data.length < productsAmount) {
      getFullList();
    }
  };

  const formatCSVData = (csvData) => {
    let newData = [...csvData]; // copying the old array
    let updatedArr = [];
    let timeZoneOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZone: "Australia/Sydney",
    };

    newData.forEach((item) => {
      if (item.margin) {
        item.margin = item.margin * 100;
      }
      if (item.rrp) {
        item.rrp = Number(item.rrp) / 100;
      }
      if (item.unitRRP) {
        item.unitRRP = Number(item.unitRRP) / 100;
      }
      if (item.unitCostPrice) {
        item.unitCostPrice = Number(item.unitCostPrice) / 100;
      }
      if (item.unitPrice) {
        item.unitPrice = Number(item.unitPrice) / 100;
      }
      if (item.totalCostPrice) {
        item.totalCostPrice = Number(item.totalCostPrice) / 100;
      }
      if (item.costPrice) {
        item.costPrice = Number(item.costPrice) / 100;
      }
      if (item.freight) {
        item.freight = Number(item.freight) / 100;
      }
      if (item.sellingPrice) {
        item.sellingPrice = Number(item.sellingPrice) / 100;
      }
      if (item.createdAt) {
        item.createdAt = new Intl.DateTimeFormat(
          "en-AU",
          timeZoneOptions
        ).format(new Date(item.createdAt));
      }
      if (item.updatedAt) {
        item.updatedAt = new Intl.DateTimeFormat(
          "en-AU",
          timeZoneOptions
        ).format(new Date(item.updatedAt));
      }
      let renamedObj = renameKeys(item);

      updatedArr.push(renamedObj);
    });

    return updatedArr;
  };

  function renameKeys(obj) {
    const keyValues = Object.keys(obj).map((key) => {
      let newKey = key;

      const rowsListName = rowList.filter((head) => head.id === key);
      if (rowsListName.length > 1) {
        let returnedObject = {};

        rowsListName.forEach((row) => {
          if (row.nestedObject) {
            // console.log("row", row);
            newKey = row.nestedObjectProperty;
            if (obj[key][row.objectProperty]) {
              returnedObject[newKey] = obj[key][row.objectProperty][0][newKey];
            }
          } else if (row.object) {
            newKey = row.objectProperty;
            returnedObject[newKey] = obj[key][newKey];
          }
        });
        return returnedObject;
      }

      if (rowsListName[0].nestedObject) {
        newKey = rowsListName[0].nestedObjectProperty;
        if (obj[key][rowsListName[0].objectProperty]) {
          return {
            [rowsListName[0].label]:
              obj[key][rowsListName[0].objectProperty][0][
                rowsListName[0].nestedObjectProperty
              ],
          };
        }
      } else if (rowsListName[0].object) {
        newKey = rowsListName[0].objectProperty;
        return { [newKey]: obj[key][newKey] };
      } else {
        return { [newKey]: obj[key] };
      }
    });
    return Object.assign({}, ...keyValues);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColSelect = () => {
    let selectedNames = rowsSelected
      .filter((row) => row.checked)
      .map((row) => row.id);

    let keysList = data[0] ? Object.keys(data[0]) : [];
    let keepCols = keysList.filter((col) => selectedNames.includes(col));

    const filtered = data.map((dataItem) =>
      keepCols.reduce((obj, key) => {
        return {
          ...obj,
          [key]: Array.isArray(dataItem[key])
            ? dataItem[key] &&
              dataItem[key]
                .map(function (obj) {
                  return obj.name || obj.objName;
                })
                .join(", ")
            : dataItem[key],
        };
      }, {})
    );
    return formatCSVData(filtered);
  };

  const handleRowFilter = (event) => {
    setRowList(
      rowsSelected.map((item) =>
        item.id === [event.target.name][0]
          ? { ...item, checked: event.target.checked }
          : item
      )
    );
  };

  return (
    <div style={{ display: "flex" }}>
      <IconButton
        aria-label="csv download"
        aria-haspopup="true"
        onClick={handleClick}
        style={{
          marginRight: 8,
          // marginTop: 16,
          color: "#fff",
          paddingLeft: 8,
          paddingRight: 8,
        }}
      >
        <CloudDownloadIcon />
      </IconButton>
      <Menu
        id="column-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            minWidth: 250,
            padding: 16,
            paddingBottom: 8,
            paddingTop: 24,
          },
        }}
      >
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            style={{
              paddingLeft: 16,
              marginBottom: 8,
              fontWeight: "bold",
              fontSize: 20,
            }}
          >
            CSV Download
          </FormLabel>

          <TextField
            style={{ marginLeft: 16, marginBottom: 16 }}
            variant="outlined"
            required
            margin="dense"
            id="filename"
            label="Filename"
            name="filename"
            autoComplete="text"
            onChange={(e) => setFileName(e.target.value)}
          />

          <Typography style={{ paddingLeft: 16, marginBottom: 16 }}>
            Select columns to include
          </Typography>
          <FormGroup>
            {rowsSelected.map((option) => (
              <MenuItem
                key={option.label}
                style={{ padding: 0, paddingLeft: 16 }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={option.checked}
                      onChange={handleRowFilter}
                      name={option.id}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </FormGroup>

          {data.length == productsAmount ? (
            <CSVDownloader
              data={handleColSelect}
              type="button"
              filename={fileName}
              bom={true}
              config={{}}
              style={{
                border: "none",
                padding: 0,
                marginTop: 24,
              }}
            >
              <ColorButton> Download</ColorButton>
            </CSVDownloader>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: 20,
              }}
            >
              <CircularProgress color="secondary" />
            </div>
          )}
          <FormHelperText style={{ paddingLeft: 16, marginTop: 24 }}>
            {/* Be careful */}
          </FormHelperText>
        </FormControl>
      </Menu>
    </div>
  );
}
